import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from 'contexts/ThemeContext';

import { HelpTooltip, Text } from 'components/DataDisplay';
import { Container, Item, Row } from 'components/Layout';

export const FormSection = props => {
  const { children, title, error, justify, tooltip } = props;
  const { themeColors } = useTheme();
  const { bgBar, inkSoft, line } = themeColors.designSystem;

  return (
    <Container style={{ marginBottom: '20px' }}>
      <Row spacing={0}>
        <Item
          flex
          justify="flex-start"
          style={{
            width: '100%',
            gap: '8px',
            marginBottom: '8px',
            padding: '7px 11px',
            borderRadius: '6px',
            backgroundColor: bgBar
          }}
        >
          <Text
            uppercase
            bold
            fontSize="12px"
            color={error ? themeColors.error : inkSoft}
            style={{ letterSpacing: '0.4px', whiteSpace: 'nowrap' }}
          >
            {title}
          </Text>
          {tooltip && <HelpTooltip title={tooltip} />}
          <Item
            flex
            style={{ flex: 1, height: '1px', backgroundColor: line }}
          />
        </Item>
      </Row>
      <Row spacing={1}>
        <Item justify={justify}>{children}</Item>
      </Row>
    </Container>
  );
};

FormSection.defaultProps = {
  error: false,
  justify: 'center',
  tooltip: false
};
FormSection.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  error: PropTypes.bool,
  justify: PropTypes.string,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default FormSection;
